import { useApp } from '../context/AppContext';
import NotificationPanel from './NotificationPanel';

const PAGE_TITLES = {
  rentals:     'Rental Management',
  calendar:    'Booking Calendar',
  incoming:    'Incoming Bookings',
  map:         'Live Map & Tracking',
  fleet:       'Fleet & Pricing',
  maintenance: 'Maintenance Tracker',
  history:     'Rental History',
  invoices:    'Pro Formas',
  refunds:     'Refunds',
  revenue:     'Revenue & Payments',
  customers:   'Customers',
  bookingsetup:'Booking Page Setup',
  agreement:   'Agreements',
  roles:       'Users & Roles',
  settings:    'Company Settings',
};

export default function Topbar({ onAction }) {
  const { currentPage, unreadCount, notifPanelOpen, setNotifPanelOpen, openModal, showToast, isMobile, setSidebarOpen } = useApp();
  const title = PAGE_TITLES[currentPage] || currentPage;

  return (
    <div className="topbar" style={{ position: 'relative' }}>
      {/* Hamburger — mobile only */}
      {isMobile && (
        <button
          onClick={() => setSidebarOpen(o => !o)}
          style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 6, display: 'flex', alignItems: 'center', marginRight: 4 }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 20, height: 20 }}>
            <path d="M3 12h18M3 6h18M3 18h18"/>
          </svg>
        </button>
      )}
      <div>
        <div className="tb-title">{title}</div>
        <div className="tb-sub">
          {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })} · Paphos, Cyprus
        </div>
      </div>

      {/* Notification Bell */}
      <div
        className="bell-wrap"
        onClick={() => setNotifPanelOpen(!notifPanelOpen)}
        style={{ cursor: 'pointer', position: 'relative', display: 'flex', alignItems: 'center' }}
      >
        <div className="bell-btn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 18, height: 18 }}>
            <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
            <path d="M13.73 21a2 2 0 01-3.46 0"/>
          </svg>
        </div>
        {unreadCount > 0 && (
          <div className="bell-dot" style={{
            position: 'absolute', top: -2, right: -2,
            width: 8, height: 8, borderRadius: '50%',
            background: 'var(--ac)', border: '2px solid var(--sur)'
          }} />
        )}
      </div>

      {/* Page Actions */}
      <div id="topbar-actions">
        <TopbarActions page={currentPage} openModal={openModal} showToast={showToast} />
      </div>

      {/* Notification Panel */}
      {notifPanelOpen && <NotificationPanel />}
    </div>
  );
}

function TopbarActions({ page, openModal, showToast }) {
  const { canEdit } = useApp();

  // Only show action buttons if user has edit permission for this page
  switch (page) {
    case 'rentals':
      return canEdit('rentals') ? (
        <button className="btn btn-primary" onClick={() => openModal('add-rental')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ width: 12, height: 12 }}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add Rental
        </button>
      ) : null;
    case 'fleet':
      return canEdit('fleet') ? (
        <button className="btn btn-primary" onClick={() => openModal('add-vehicle')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ width: 12, height: 12 }}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Add Vehicle
        </button>
      ) : null;
    case 'calendar':
      return canEdit('calendar') ? <button className="btn btn-primary btn-sm" onClick={() => openModal('add-rental')}>+ New Booking</button> : null;
    case 'customers':
      return canEdit('customers') ? <button className="btn btn-primary" onClick={() => openModal('add-customer')}>+ Add Customer</button> : null;
    case 'agreement':
      return canEdit('agreement') ? <button className="btn btn-primary btn-sm" onClick={() => openModal('agreement')}>+ Agreement</button> : null;
    case 'maintenance':
      return canEdit('maintenance') ? <button className="btn btn-primary btn-sm" onClick={() => openModal('add-maintenance')}>+ Log Service</button> : null;
    case 'invoices':
      return canEdit('invoices') ? (
        <button className="btn btn-primary" onClick={() => openModal('create-invoice')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ width: 12, height: 12 }}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          New Pro Forma
        </button>
      ) : null;
    case 'map':
      return canEdit('map') ? <button className="btn btn-ghost btn-sm" onClick={() => openModal('add-poi')}>📍 Add POI</button> : null;
    case 'roles':
      return canEdit('roles') ? <button className="btn btn-primary btn-sm" onClick={() => openModal('invite-user')}>+ Invite User</button> : null;
    case 'settings':
      return canEdit('settings') ? <button className="btn btn-primary btn-sm" onClick={() => showToast('Settings saved')}>Save Settings</button> : null;
    default:
      return null;
  }
}
